import React, { useState } from "react";
import {
  TableEditBtn,
  TableViewBtn,
  TableDeleteBtn,
} from "../../../images/Svgs";
import { Base_Url } from "../../../API/config";
import { useNavigate } from "react-router";
import { CustomToolTip, formatAMPM, formatDate } from "../../../utils/common";
const Eventlist = ({ allEvent, handleEditEvent, handleDeleteEvent }) => {
  const navigate = useNavigate();
  return (
    <div class="event_list_table mt-4">
      <div class="col-md-12 col-12">
        <div class="table-sec">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Images</th>
                  <th scope="col">Events Name</th>
                  <th scope="col">Date/Time</th>
                  <th scope="col">Location</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {allEvent &&
                  allEvent.length > 0 &&
                  allEvent.map((item) => {
                    return (
                      <tr>
                        <td>
                          <p>
                            <img
                              src={`${Base_Url}/${item.event_img}`}
                              onClick={() => navigate(`/events/${item?.id}`)}
                              alt=""
                            />
                          </p>
                        </td>
                        <td class="hd-subtitle">
                          <p class="boom">{item?.event_title}</p>
                        </td>
                        <td class="hd-subtitle">
                          {formatDate(item?.event_date)},{" "}
                          {formatAMPM(item?.event_time_from)}
                        </td>
                        <td class="hd-subtitle" width="20%">
                          {item?.event_location}
                        </td>
                        <td class="approval-status-tbl">
                          <button
                            type="button"
                            class="btn  position-relative"
                            onClick={() => handleEditEvent(item)}
                          >
                            <TableEditBtn />
                            <CustomToolTip type="edit" title="Event" />
                          </button>
                          <button
                            type="button"
                            class="btn  position-relative"
                            onClick={() => navigate(`/events/${item?.id}`)}
                          >
                            <TableViewBtn />{" "}
                            <CustomToolTip type="view" title="Event" />
                          </button>
                          <button
                            type="button"
                            class="btn  position-relative"
                            onClick={() => handleDeleteEvent(item?.id)}
                          >
                            <TableDeleteBtn />
                            <CustomToolTip type="delete" title="Event" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div> 
        </div>
      </div>
    </div>
  );
};
export default Eventlist;
